"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var _ = tslib_1.__importStar(require("@antv/util"));
var event_1 = require("../../util/event");
exports.EVENT_MAP = event_1.EVENT_MAP;
exports.onEvent = event_1.onEvent;
var SHAPE_EVENT_MAP = {
    onRingClick: 'interval:click',
    onRingDblclick: 'interval:dblclick',
    onRingMousemove: 'interval:mousemove',
    onRingMouseenter: 'interval:mouseenter',
    onRingMouseleave: 'interval:mouseleave',
    onRingMousedown: 'interval:mousedown',
    onRingMouseup: 'interval:mouseup',
    onRingContextmenu: 'interval:contextmenu',
};
_.assign(event_1.EVENT_MAP, SHAPE_EVENT_MAP);
//# sourceMappingURL=event.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/plots/ring/event.js
// module id = 966
// module chunks = 37